<template>
  <BbPopup v-model="confirmPopupOpened" :showCloseIcon="true" contentClass="create-collection-dialog">
    <template #popup-header>
      <TextBody
        tag="span"
        :i18n-key="isEditMode ? 'glossaries.savePopup.updateGlossaryName' : 'glossaries.savePopup.createGlossary'"
        :body-type="3"
        weight="medium"
      />
    </template>
    <div class="info-container">
      <BbInput
        v-model="newTitle"
        placeholder=""
        :label="t('collections.createPopup.title')"
        size="small"
        :rules="rules"
        :autofocus="true"
        :maxlength="GLOSSARY_TITLE_MAX_LENGTH"
        :hint="titleLimitHint"
      />
    </div>
    <template #popup-actions>
      <BbBtn type="secondary" @click="confirmPopupOpened = false">
        <TextBody i18n-key="common.cancel" />
      </BbBtn>
      <BbBtn color="#6222e3" @click="save" :is-disabled="isTitleInvalid()">
        <TextBody :i18n-key="isEditMode ? 'common.update' : 'common.create'" />
      </BbBtn>
    </template>
  </BbPopup>
</template>

<script>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import TextBody from '~/components/common/TextBody';
import { GLOSSARY_TITLE_MAX_LENGTH } from '~/constants/glossaries';

export default {
  components: { TextBody },
  props: {
    popupOpened: {
      type: Boolean,
      default: false,
    },
    glossaryTitle: {
      type: String,
      default: '',
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const newTitle = ref(props.glossaryTitle);

    const titleMaxLengthMessage = () => t('glossaries.savePopup.titleMaxLength', { max: GLOSSARY_TITLE_MAX_LENGTH });

    const rules = [
      (v) => !!v || t('modals.titleShouldNotBeEmpty'),
      (v) => v.length <= GLOSSARY_TITLE_MAX_LENGTH || titleMaxLengthMessage(),
    ];

    const titleLimitHint = computed(() =>
      newTitle.value.length >= GLOSSARY_TITLE_MAX_LENGTH ? titleMaxLengthMessage() : '',
    );

    const confirmPopupOpened = computed({
      get: () => props.popupOpened,
      set: (val) => emit('update:open', val),
    });

    const save = () => {
      emit('execute:action', { title: newTitle.value.trim() });
    };

    const isTitleInvalid = () => {
      const title = newTitle.value.trim();
      return !title || title.length > GLOSSARY_TITLE_MAX_LENGTH;
    };

    return {
      confirmPopupOpened,
      emit,
      GLOSSARY_TITLE_MAX_LENGTH,
      isTitleInvalid,
      newTitle,
      rules,
      save,
      t,
      titleLimitHint,
    };
  },
};
</script>
